export const PRODUCT_SORTS = ['price_asc', 'price_desc', 'name_asc', 'name_desc'] as const

export type ProductSort = (typeof PRODUCT_SORTS)[number]

export function parseProductSort(value: unknown): ProductSort | null {
  const raw = Array.isArray(value) ? value[0] : value
  if (typeof raw !== 'string') return null
  return (PRODUCT_SORTS as readonly string[]).includes(raw) ? (raw as ProductSort) : null
}
